import { IAction } from "../model/IAction";

export const REMOVE_ARRAY_ELEMENT = "REMOVE_ARRAY_ELEMENT";
export function removeArrayElement(elementId: string, key: string, index: number): RemoveArrayElementAction {
  return {
    type: REMOVE_ARRAY_ELEMENT,
    elementId: elementId,
    key: key,
    index: index
  };
}
export interface RemoveArrayElementAction extends IAction {
  elementId: string;
  key: string;
  index: number;
}
